import {
  Route,
  Switch,
  useHistory,
  useLocation,
  Redirect,
} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import CompanyInfo from '../components/CompanyInfo';
import useLocalStorage from 'hooks/use-local-storage';
import AppContext, {StepStatus} from '../context/app-context';
import LoginPage from './login';
import PasswordEnablePage from './passwordEnable';
import ZeroPage, {STEP as ZERO_STEP} from './StepZero';
import JobTitleSettingPage from './job-title-setting';
import EmployeeDataPage from './StepEmployeeData';
import OrgDataPage from './StepOrgData';
import AdminSettingPage from './StepAdmin';
import ActivePage from './StepActive';
import CheckInSettingPage from './check-in-setting/index';
import AttendanceQAPage from './attendance-question/';
import ShiftScheduleSetting from './shift-schedule';
import RemainLeave from './remain-leave';
import PayrollParameterSetting from './payroll-parameter-setting';
import EmployeeSalarySetting from './employee-salary-setting';
import StepPYQuestions from './step-py-questions';
import {DateTime} from 'luxon';
import Layout from '../components/Layout';
import CompanyStore, {
  CompanyContext,
  Employee,
} from '../context/company-context';
import {useAuthContext, useClient} from '../context/auth-context';
import {useQuery} from 'react-query';
import FullPageLoader from '../components/FullPageLoader';
import logo from '../../../assets/company_logo.svg';
import User from '../model/User';
import stepConfig from '../step-config';
import {toast} from 'react-toastify';
import cx from 'classnames';
import NoticeDialog, { Props as NoticeDialogProps } from '@gakki/components/Dialog/NoticeDialog';

let InitialCompanyInfo = {
  account: '',
  amountOfLicense: 0,
  code: '',
  customerId: 0,
  name: '',
  seniorityId: '',
  step: 0,
  vat: '',
  employee: [],
  companyId: '',
  enablePY: true,
};

export function IndexPage() {
  const api = useClient();
  const {companyId, logout} = useAuthContext();
  const [step, setStep] = useLocalStorage<number>('step', 0);
  const [updatedTime, setUpdatedTime] = useLocalStorage<string>(
    'updatedTime',
    '',
  );
  const [data, setData] = useLocalStorage<object | object[] | null>(
    'data',
    null,
  );
  const [stepStatus, setStepStatus] = useLocalStorage<StepStatus>(
    'stepStatus',
    StepStatus.init,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isDefault, setIsDefault] = useState(false);
  const [isInit, setIsInit] = useState(false);
  const [noticeDialogProps, setNoticeDialogProps] = useState<NoticeDialogProps | null>(null)
  const [progressStep, setProgressStep] = useLocalStorage<number>('progressStep', 0);
  const [previousEnablePY, setPreviousEnablePY] = useLocalStorage<boolean | null>('previousEnablePY', null);
  const [saveAndGoStep, setSaveAndGoStep] = useState<null | number>(null)
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname !== `/gakki/step/${step}`) {
      history.push(`/gakki/step/${step}${location.search}`);
    }
  }, [step, location, history]);

  const {data: company, isLoading: isCompanyLoading, isFetching: isCompanyFetching, refetch: refetchCompany} = useQuery<
    CompanyContext & {progressState: number; enablePY: boolean}
  >('company', () => api.get(`company/${companyId}`).then(d => d.data), {
    onSuccess: d => {
      if (!isInit) {
        setIsInit(true);
        setPreviousEnablePY(d.enablePY)
        if (!d.enablePY && (isPYStep(d.progressState) || isPYStep(step))) {
          setStep(11);
          setProgressStep(11);
        } else {
          setStep(d.progressState || ZERO_STEP);
          setProgressStep(d.progressState || ZERO_STEP);
        }
      }
    },
  });
  const {data: employeeList, isFetching: isEmployeeFetching } = useQuery<{ staffName: any[] }>(
    'employee-list',
    () => api.get(`staff/company/${companyId}/name`),
  );

  useEffect(() => {
    if (step === 0 || step === null) {
      setStep(company?.progressState || 0);
    }
  }, [company, step, setStep]);

  useEffect(() => {
    if(stepStatus === StepStatus.updated) {
      isDefault && setIsDefault(false);
    }
  }, [stepStatus])

  const isBehindPYStep = (step?: number) => typeof step === 'number' && [11,12].includes(step)
  const isPYStep = (step?: number) => typeof step === 'number' && [8,9,10].includes(step)
  const refetchEnablePY = async (action: 'save' | 'next' | 'prev' | 'nav', nextStep: number) => {
    const { data } = await refetchCompany()
    if (data && previousEnablePY !== data.enablePY) {
      setPreviousEnablePY(data.enablePY)
      if (data.enablePY) {
        if ((isBehindPYStep(step) || isBehindPYStep(nextStep))) {
          if (['save', 'prev', 'next'].includes(action)) {
            setStepStatus(StepStatus.init);
            setStep(8);
          }
          setProgressStep(8);
          toast.info('智慧結薪模組 已開啟，請確認相關資料', {
            hideProgressBar: true,
            position: 'top-center',
          });
          throw new Error('NotEnablePY')
        } else {
          if (isBehindPYStep(progressStep)) {
            setProgressStep(8);
            toast.info('智慧結薪模組 已開啟，請確認相關資料', {
              hideProgressBar: true,
              position: 'top-center',
            });
          } else {
            toast.info('智慧結薪模組 已開啟', {
              hideProgressBar: true,
              position: 'top-center',
            });
          }
        }
      } else {
        if (action === 'nav' && isPYStep(progressStep)) {
          setProgressStep(11);
        }
        if (isPYStep(nextStep)) {
          setStep(11);
          setProgressStep(11);
        }
        toast.info('智慧結薪模組 已關閉', {
          hideProgressBar: true,
          position: 'top-center',
        });
      }
    }
    return Promise.resolve({
      enablePY: data?.enablePY,
      progressState: data?.progressState,
    });
  }
  const onStepChange = async (step: number) => {
    if (stepStatus === StepStatus.edit) {
      setSaveAndGoStep(step);
    } else if (isPYStep(step)) {
      const newCompany = await refetchEnablePY('nav', step);
      if (newCompany?.enablePY) {
        setStepStatus(StepStatus.init);
        setStep(step);
      }
    } else if (isBehindPYStep(step) && previousEnablePY === false) {
      const newCompany = await refetchEnablePY('nav', step);
      if (newCompany?.enablePY) {
        setStepStatus(StepStatus.init);
        setStep(8);
      } else {
        setStepStatus(StepStatus.init);
        setStep(step);
      }
    } else {
      refetchEnablePY('nav', step);
      setStepStatus(StepStatus.init);
      setStep(step);
    }
  }

  const onSaveAndGoStep = () => {
    if (typeof saveAndGoStep === 'number') {
      setStepStatus(StepStatus.init);
      setSaveAndGoStep(null);
      setStep(saveAndGoStep);
    }
  }

  const changeStep = (newStep: number) => {
    setData(null);
    setStepStatus(StepStatus.init);
    setStep(newStep);
    if (newStep > step) {
      setProgressStep(newStep);
    }
  }

  const onPrev = async () => {
    if (isPYStep(step)) {
      const newCompany = await refetchEnablePY('prev', step - 1);
      if (!newCompany?.enablePY) {
        changeStep(7);
      } else {
        changeStep(step - 1);
      }
    } else if (step === 11) {
      const newCompany = await refetchEnablePY('prev', 7);
      if (previousEnablePY === false && newCompany?.enablePY) {
      } else if (!newCompany?.enablePY) {
        changeStep(7);
      } else {
        changeStep(step - 1);
      }
    } else {
      refetchEnablePY('prev', step - 1);
      changeStep(step - 1);
    }
  }
  const getEmployeeList = () => {
    const isGetEmployeeList = step === stepConfig.foundation.steps.employee.step;
    return isGetEmployeeList &&
    data &&
    data instanceof Array
      ? (data as User[]).map(d => {
          return {
            id: d.id,
            employeeNumber: `${d.code}${d.seqNo}`,
            name: `${d.lastName}${d.firstName}`,
            onBoardingDate: d.onboardingDate || '',
            businessEmail: d.businessEmail || '',
          };
        })
      : employeeList?.staffName?.map(
        (s: {
          firstName: string;
          lastName: string;
          id: string;
          jobNo: string;
          onboardingDate: string;
          businessEmail: string;
        }) => ({
          id: s.id,
          name: `${s.lastName}${s.firstName}`,
          lastName: s.lastName,
          firstName: s.firstName,
          employeeNumber: s.jobNo,
          jobNo: s.jobNo,
          onBoardingDate: s.onboardingDate,
          businessEmail: s.businessEmail,
        }),
      ) || []
  }

  let companyInfo = {
    ...InitialCompanyInfo,
    ...company,
    companyId,
    employee: getEmployeeList(),
  };

  if (isCompanyLoading || isEmployeeFetching) {
    return <FullPageLoader />;
  }

  return (
    <CompanyStore.Provider value={companyInfo}>
      <AppContext.Provider
        value={{
          step,
          saveAndGoStep,
          updatedTime,
          data,
          stepStatus,
          isLoading,
          setIsLoading,
          isDefault,
          setIsDefault,
          setNoticeDialogProps,
          onSaveAndGoStep,
          refetchEnablePY,
          changeStep,
          onPrev,
          init: data => {
            setData(data);
            setStepStatus(StepStatus.init);
          },
          edit: data => {
            setStepStatus(StepStatus.edit);
            setData(data);
          },
          save: async () => {
            toast.success('儲存成功', {
              hideProgressBar: true,
              position: 'top-center',
            });
            const newCompany = await refetchEnablePY('save', step);
            if (typeof saveAndGoStep === 'number') {
              if (!isPYStep(saveAndGoStep) || (isPYStep(saveAndGoStep) && newCompany?.enablePY)) {
                onSaveAndGoStep()
              }
            } else {
              setStepStatus(StepStatus.updated);
            }
            if (!newCompany?.enablePY && isPYStep(step)) {
            } else {
              setProgressStep(step);
            }
            setUpdatedTime(DateTime.now().toFormat('yyyy/MM/dd HH:mm'));
          },
          confirm: async () => {
            toast.success('儲存成功', {
              hideProgressBar: true,
              position: 'top-center',
            });
            setStepStatus(StepStatus.updated);
            setUpdatedTime(DateTime.now().toFormat('yyyy/MM/dd HH:mm'));
          },
          saveFail: () => {
            setSaveAndGoStep(null);
          },
        }}
      >
        {(isLoading || isCompanyFetching) && <FullPageLoader />}
        <header className={'fixed w-screen top-0 left-0 right-0 z-10'}>
          <div
            className={
              'h-[52px] px-[13px] py-[9px] bg-[#353d45] flex justify-between'
            }
          >
            <img src={logo} alt={'mayo-logo'} />
            <button
              className={cx(
                'logout-btn',
                'text-white bg-transparent py-[5px] px-[25px] border border-white rounded-[3px]',
              )}
              onClick={logout}
            >
              登出
            </button>
          </div>
          <Layout.ImportStep
            enablePY={companyInfo.enablePY}
            progressStep={progressStep}
            onStepChange={onStepChange}
          />
          <CompanyInfo
            name={companyInfo.name}
            vat={companyInfo.vat}
            amountOfLicense={companyInfo.amountOfLicense}
            amountOfEmployee={companyInfo.employee.length}
          />
        </header>
        <Layout.Main noPadding={step === stepConfig.foundation.steps.org.step}>
          <Switch>
            <Route path={`/gakki/step/${ZERO_STEP}`}>
              <ZeroPage />
            </Route>
            <Route
              path={`/gakki/step/${stepConfig.foundation.steps.jobTitle.step}`}
            >
              <JobTitleSettingPage />
            </Route>
            <Route
              path={`/gakki/step/${stepConfig.foundation.steps.employee.step}`}
            >
              <EmployeeDataPage />
            </Route>
            <Route path={`/gakki/step/${stepConfig.foundation.steps.org.step}`}>
              <OrgDataPage />
            </Route>
            <Route path={`/gakki/step/${stepConfig.attendance.steps.qa.step}`}>
              <AttendanceQAPage />
            </Route>
            <Route
              path={`/gakki/step/${stepConfig.attendance.steps.checkIn.step}`}
            >
              <CheckInSettingPage />
            </Route>
            <Route
              path={`/gakki/step/${stepConfig.attendance.steps.remainLeave.step}`}
            >
              <RemainLeave />
            </Route>
            <Route
              path={`/gakki/step/${stepConfig.attendance.steps.shiftSchedule.step}`}
            >
              <ShiftScheduleSetting />
            </Route>
            {
              companyInfo.enablePY &&
              <Route path={`/gakki/step/${stepConfig.payroll.steps.qa.step}`}>
                <StepPYQuestions />
              </Route>
            }
            {
              companyInfo.enablePY &&
              <Route
                path={`/gakki/step/${stepConfig.payroll.steps.company.step}`}
              >
                <PayrollParameterSetting />
              </Route>
            }
            {
              companyInfo.enablePY &&
              <Route
                path={`/gakki/step/${stepConfig.payroll.steps.employee.step}`}
              >
                <EmployeeSalarySetting />
              </Route>
            }
            <Route path={`/gakki/step/${stepConfig.active.steps.admin.step}`}>
              <AdminSettingPage />
            </Route>
            <Route path={`/gakki/step/${stepConfig.active.steps.active.step}`}>
              <ActivePage />
            </Route>
          </Switch>
        </Layout.Main>
        <NoticeDialog
          onCancel={() => setNoticeDialogProps(null)}
          onConfirm={() => setNoticeDialogProps(null)}
          text={noticeDialogProps?.text}
          isOpen={Boolean(noticeDialogProps?.isOpen)}
        />
      </AppContext.Provider>
    </CompanyStore.Provider>
  );
}

export default function AppRouter() {
  const {isLogin} = useAuthContext();

  return (
    <Switch>
      <Route path="/gakki/login">
        <LoginPage />
      </Route>
      <Route path="/gakki/password-enable">
        <PasswordEnablePage />
      </Route>
      <Route
        path="/"
        render={() =>
          isLogin ? (
            <IndexPage />
          ) : (
            <Redirect
              to={{
                pathname: '/gakki/login',
              }}
            />
          )
        }
      />
    </Switch>
  );
}
